export default __webpack_public_path__ + "static/media/ONE_AND_ONE.b122e419.png";